<template>
  <div class="opc-pbx__section" :class="showHead && showAction && 'opc-pbx__section--divided'">
    <div class="opc-pbx__section__inner" v-show="showHead">
      <div class="opc-pbx__section__title">
        <slot name="title" />
      </div>
      <div class="opc-pbx__section__desc">
        <slot name="description" />
      </div>
      <div :class="isSingle ? 'opc-pbx__section__main_single' : 'opc-pbx__section__main'" >
        <slot />
      </div>
    </div>
    <div class="opc-pbx__section__action" v-show="showAction">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showHead: {
      type: Boolean,
      default: true,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    isSingle:{
      type: Boolean,
      default: false,
    }
  },
  /*
  data() {
    return {
      observer: null,
    };
  },
  methods: {
    updateView() {
      const mainDom = this.$el.querySelector('.opc-pbx__section__main');
      this.showHead = !!mainDom?.childNodes?.length;
      const actionDom = this.$el.querySelector('.opc-pbx__section__action');
      this.showAction = !!actionDom?.childNodes?.length;
    },
  },
  mounted: function () {
    this.observer = new MutationObserver(
      function () {
        this.updateView();
      }.bind(this),
    );
    const dom = this.$el.querySelector('.opc-pbx__section__main');
    this.observer.observe(dom, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
    this.updateView();
  },
  beforeUnmount: function () {
    this.observer.disconnect();
  },
  */
};
</script>

<style lang="scss" scoped>
@import '@/styles/animate.scss';
.opc-pbx {
  $gap: 12px;
  &__section {
    position: relative;
    background: var(--zoom-color-fill-subtler-neutral, #F7F9FA);
    border-radius: 10px;
    animation: fadein 0.3s normal forwards ease-in-out;
    animation-iteration-count: 1;
    animation-delay: 0s;
    margin-bottom: $gap;
    &:last-child {
      margin-bottom: 0;
    }
    &__inner {
      padding: $gap 10px;
      padding-bottom: 0;
    }
    &__title {
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }
    &__desc {
      font-weight: 450;
      font-size: 14px;
      line-height: 22px;
      color: var(--zoom-color-text-neutral, #686F79);
    }
    &__main {
      padding: $gap 0;
      &_single{
        padding-top: 0;
      }
    }
    &__main_single {
      padding: 0 0 $gap;
    }
    &--divided &__main {
      border-bottom: 1px solid var(--zoom-color-border-subtle-neutral, #DFE3E8);
    }
    &__action {
      text-align: center;
      padding: $gap 10px;
      :deep .zbo-button {
        padding: 0px;
      }
    }
  }
}
</style>
